/* eslint-disable prettier/prettier */
import { defineComponent } from "vue";

import { IMatchingAnswer } from "@/services/data/matching-questionary/matching-answer.interface";
import { IMatchingQuestion } from "@/services/data/matching-questionary/matching-question.interface";
import { IMatchingResponse } from "@/services/data/matching-responses/matching-response.interface";

import moment from "moment";

export default defineComponent({
  name: "FormatMatchingResponseValuesMixin",

  methods: {
    parseFloatAsString(value: number | string): string {
      return parseFloat(value.toString().replace(/,/g, "")).toLocaleString();
    },

    formatFreeResponseValue(response: IMatchingResponse): string {
      return response?.value?.text !== undefined ? response.value.text : "";
    },

    formatDateValue(response: IMatchingResponse): string {
      return response?.value?.date !== undefined
        ? moment(response.value.date, "YYYY-MM-DD").format("Do MMMM, YYYY")
        : "";
    },

    formatNumericValue(response: IMatchingResponse): string {
      return response.value && response?.value.value
        ? this.parseFloatAsString(response.value.value)
        : "";
    },

    formatMoneyValue(value: string | number) {
      return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      }).format(+value);
    },

    formatRangeValue(response: IMatchingResponse): string {
      const minValue =
        response?.value?.min === 0 || !!response?.value?.min
          ? response?.value?.min
          : undefined;

      const maxValue =
        response?.value?.max === 0 || !!response?.value?.max
          ? response?.value?.max
          : undefined;

      return minValue !== undefined && maxValue !== undefined
        ? `From ${this.formatMoneyValue(minValue)} to ${this.formatMoneyValue(
          maxValue,
        )}`
        : response?.value?.value
          ? `${this.formatMoneyValue(response?.value?.value)}`
          : "";
    },


    formatMultipleAnswersValue(
      question: IMatchingQuestion,
      response: IMatchingResponse,
    ): string {
      const answersText: Array<string> = [];

      response.answers.forEach((answerId: number) => {
        let answers: IMatchingAnswer | undefined;

        if (["sdg-industry", "sdg-activities"].includes(question.slug || "")) {
          const options = this.$store.state.affiliates.sdgQuestionOptions[
            question.slug === "sdg-industry" ? "industries" : "activities"
          ]
          answers = options.find((opt: IMatchingAnswer) => opt.id === answerId)
        } else {
          answers = question.answers.find(
            (answer: IMatchingAnswer) => answer.id === answerId,
          );
        }

        answersText.push(answers?.value || "");
      });

      return answersText.join(", ");
    },
  },
});
